import {ChangeDetectionStrategy, Component, Signal} from "@angular/core";
import {navParam} from "../../../navigation/navigation-params";
import {NavigationService} from "../../../navigation/navigation.service";
import {Page} from "../../../navigation/page";
import {ModalPageLayoutComponent} from '../../../page-layout/modal-page-layout/modal-page-layout.component';
import {QrCodeComponent} from "../qr-code/qr-code.component";

@Component({
    selector: "woa-qr-code-page",
    templateUrl: "./qr-code-page.component.html",
    styleUrl: "./qr-code-page.component.scss",
    providers: [{provide: Page, useExisting: QrCodePageComponent}],
    imports: [
        ModalPageLayoutComponent,
        QrCodeComponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class QrCodePageComponent extends Page {
    public readonly value: Signal<string> = navParam.required<string>("value");
    public readonly displayValue: Signal<string> = navParam<string>("displayValue", this.value());
    public readonly message: Signal<string> = navParam<string>("message");

    public static async showQrCode(navigationService: NavigationService, value: string, message: string, displayValue?: string): Promise<void> {
        return navigationService.createPage("woa-qr-code-page", {
            value: value,
            displayValue: displayValue,
            message: message
        });
    }
}
